import React, { useEffect, useState } from "react";
import { Modal, Button, List, Card, Spin, notification } from "antd";
import { useMediaQuery } from "react-responsive";
import EventModal from "./modalCreateEvents";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { DeleteOutlined } from "@ant-design/icons";
import "../modal/eventCss.css";

const ModalItemCalendarList = ({
  isModalOpen,
  setIsModalOpen,
  selectedDate,
  setLoadCalendar
}) => {
  const [api, contextHolder] = notification.useNotification();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isOpenEvent, setIsOpenEvent] = useState(false);
  const [isLoadEvent, setIsLoadEvent] = useState(false);
  const [isTriggerEvent, setIsTriggerEvent] = useState(false);
  const [recordEvent, setRecordEvent] = useState();
  const [selectedEvents, setSelectedEvents] = useState([]);

  useEffect(() => {
    setIsLoadEvent(true);
    const getApi = async () => {
      try {
        const q = query(
          collection(db, "meetings"),
          where("meetStartDate", ">=", `${selectedDate} 00:00`),
          where("meetStartDate", "<=", `${selectedDate} 23:59`)
        );
        const querySnapshot = await getDocs(q);

        const filteredEvents = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSelectedEvents(filteredEvents);
      } catch (error) {
        console.error("Error fetching events: ", error);
      }
    };
    if (isModalOpen) {
      getApi();
      setIsLoadEvent(false);
    }
  }, [isModalOpen, selectedDate, isTriggerEvent]);

  console.log("selectedEvents", selectedEvents);
  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedEvents();
    setLoadCalendar(c =>!c)
  };

  const getRandomPastelColor = () => {
    const r = Math.floor(Math.random() * 127 + 128); // ค่า RGB 128-255
    const g = Math.floor(Math.random() * 127 + 128);
    const b = Math.floor(Math.random() * 127 + 128);
    const alpha = 0.5; // ความโปร่งใส (0.0 - 1.0)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const showModalOpenEvent = (record) => {
    setRecordEvent(record);
    setIsOpenEvent(true);
  };

  const hideModalOpenEvent = () => {
    setRecordEvent();
    setIsOpenEvent(false);
  };

  const deleteDocument = async (documentId) => {
    try {
      const docRef = doc(db, "meetings", documentId);
      await deleteDoc(docRef);
      openNotificationWithIcon("success", "Deleted successfully");
      setIsTriggerEvent((c) => !c);
    } catch (error) {
      console.error("Error deleting document: ", error);
      alert("Error deleting document.");
    }
  };

  return (
    <div>
      {contextHolder}
      <Modal
        title="Events"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button onClick={() => handleCancel()}>Close</Button>,
          ,
          <Button type="primary" onClick={() => showModalOpenEvent()}>
            Create Event
          </Button>,
        ]}
        styles={{
          body: {
            height: isMobile ? "70vh" : "70vh",
            padding: isMobile ? "20px" : "24px",
            overflowX: "hidden",
            overflowY: "scroll",
          },
        }}
        style={{
          top: isMobile ? 100 : 100,
          overflowX: isMobile ? "75vh" : "auto",
        }}
        width={isMobile ? "100vw" : 520}
      >
        <Spin spinning={isLoadEvent}>
          <List
            grid={{
              gutter: 16,
              column: 1,
            }}
            dataSource={selectedEvents}
            renderItem={(item) => (
              <List.Item key={item.id}>
                <Card
                  className="event-card"
                  style={{ backgroundColor: getRandomPastelColor() }}
                  title={
                    <div
                      className="event-title"
                      onClick={() => showModalOpenEvent(item)}
                    >
                      {item.eventName}
                    </div>
                  }
                  extra={
                    <DeleteOutlined
                      className="delete-icon"
                      onClick={() => deleteDocument(item.id)}
                    />
                  }
                >
                  <p className="event-date">
                    เวลา : {item.meetStartDate} - {item.meetEndDate}
                  </p>
                  <p className="event-remark">รายละเอียด : {item.remark}</p>
                </Card>
              </List.Item>
            )}
          />
        </Spin>
      </Modal>
      <EventModal
        isOpenEvent={isOpenEvent}
        setIsOpenEvent={setIsOpenEvent}
        hideModalOpenEvent={hideModalOpenEvent}
        recordEvent={recordEvent}
        setIsTriggerEvent={setIsTriggerEvent}
      />
    </div>
  );
};

export default ModalItemCalendarList;
